import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Settings, AlertTriangle, AlertOctagon, CheckCircle2 } from 'lucide-react';
import { fadeInUp } from '../../lib/animations';


const PECAS = [
  { id: 'oleo', nome: 'Óleo do Motor (Mineral/Sintético)', validadeKm: 10000, validadeMeses: 12 },
  { id: 'correia', nome: 'Correia Dentada', validadeKm: 50000, validadeMeses: 36 },
  { id: 'pastilha', nome: 'Pastilha de Freio', validadeKm: 30000, validadeMeses: 999 },
  { id: 'fluido_freio', nome: 'Fluido de Freio', validadeKm: 40000, validadeMeses: 24 }
];

const SimuladorVidaUtil: React.FC = () => {
  const [kmAtual, setKmAtual] = useState(125000);
  const [pecaId, setPecaId] = useState(PECAS[0].id);
  const [kmUltimaTroca, setKmUltimaTroca] = useState(110000);
  const [mesesTroca, setMesesTroca] = useState(8);

  const peca = PECAS.find(p => p.id === pecaId);
  const kmRodados = kmAtual - kmUltimaTroca;
  const kmRestante = (peca?.validadeKm || 0) - kmRodados;
  const mesesRestante = (peca?.validadeMeses || 0) - mesesTroca;

  const passouKm = kmRestante < 0;
  const passouTempo = mesesRestante < 0;
  const status = (passouKm || passouTempo) ? 'CRÍTICO' : (kmRestante < 2000 || mesesRestante <= 2) ? 'ATENÇÃO' : 'OK';

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <motion.div variants={fadeInUp} className="overflow-hidden rounded-2xl bg-slate-900 shadow-xl shadow-slate-900/40 border border-slate-800">
        <div className="bg-amber-400 p-6 sm:p-8 text-center">
           <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-950/30">
            <Settings className="h-7 w-7 text-white" strokeWidth={1.8} />
          </div>
          <h2 className="font-display text-2xl font-bold text-white mb-2">Simulador de Vida Útil e Revisão</h2>
        </div>

        <div className="p-6 sm:p-8 grid gap-8 md:grid-cols-2">
           <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-400 mb-1">Qual é a KM atual do painel?</label>
                <input type="number" value={kmAtual} onChange={e => setKmAtual(Number(e.target.value))} className="w-full rounded-xl border border-slate-700 bg-slate-800 px-4 py-2.5 text-sm focus:border-amber-400 focus:outline-none" />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-400 mb-1">Selecione a Peça</label>
                <select value={pecaId} onChange={e => setPecaId(e.target.value)} className="w-full rounded-xl border border-slate-700 bg-slate-800 px-4 py-2.5 text-sm focus:border-amber-400 focus:outline-none">
                  {PECAS.map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
                </select>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-400 mb-1">KM na Troca</label>
                  <input type="number" value={kmUltimaTroca} onChange={e => setKmUltimaTroca(Number(e.target.value))} className="w-full rounded-xl border border-slate-700 bg-slate-800 px-4 py-2.5 text-sm focus:border-amber-400 focus:outline-none" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-400 mb-1">Meses Atrás</label>
                  <input type="number" value={mesesTroca} onChange={e => setMesesTroca(Number(e.target.value))} className="w-full rounded-xl border border-slate-700 bg-slate-800 px-4 py-2.5 text-sm focus:border-amber-400 focus:outline-none" />
                </div>
              </div>
           </div>

           <div className="flex flex-col justify-center">
             {status === 'CRÍTICO' && (
                <div className="bg-red-400/10 text-red-400 border border-red-400/30 p-6 rounded-xl text-center">
                  <AlertOctagon className="h-10 w-10 text-red-400 mx-auto mb-3" />
                  <h4 className="font-bold text-lg mb-1">VENCIDA! Pare o carro.</h4>
                  <p className="text-sm border-t border-red-400/30 pt-3 mt-3">Você rodou {kmRodados.toLocaleString()} km de {peca?.validadeKm} permitidos.</p>
                  <p className="text-sm font-bold mt-1 text-red-400">Risco de perder o motor ou ficar sem freio.</p>
                </div>
             )}
             {status === 'ATENÇÃO' && (
                <div className="bg-amber-400/10 text-amber-400 border border-amber-400/30 p-6 rounded-xl text-center">
                  <AlertTriangle className="h-10 w-10 text-amber-400 mx-auto mb-3" />
                  <h4 className="font-bold text-lg mb-1">Programe a Troca</h4>
                  <p className="text-sm">Restam apenas {kmRestante.toLocaleString()} km ou {mesesRestante} meses.</p>
                </div>
             )}
             {status === 'OK' && (
                <div className="bg-emerald-400/10 text-emerald-400 border border-emerald-400/30 p-6 rounded-xl text-center">
                  <CheckCircle2 className="h-10 w-10 text-emerald-400 mx-auto mb-3" />
                  <h4 className="font-bold text-lg mb-1">Tudo em Ordem</h4>
                  <p className="text-sm">Você ainda pode rodar {kmRestante.toLocaleString()} km.</p>
                </div>
             )}
           </div>
        </div>
      </motion.div>
    </div>
  );
};
export default SimuladorVidaUtil;


